export class ValidateData {
    public static emptyString(data: string): boolean {
        return data === null || data === "null" || data === undefined || data === "";
    }

    public static stringVacio(valor: string, transformacion?: 'mayus' | 'minus'): string {
        if (!valor || !this.esString(valor))
            return "";

        switch(transformacion) {
            case "mayus": {
                valor.toLowerCase();
                break;
            }
            case "minus": {
                valor.toUpperCase();
                break;
            }
            default: 
                return valor;
        }
    }

    public static esString(valor: any) {
        return typeof valor === "string";
    }

    public static emptyString2(data: string): boolean {
        return data === null || data === undefined || data === "";
    }

    public static emptyNumber(data: number): boolean {
        return data === null || data === undefined || data === 0;
    }

    public static emptyObject(data: any): boolean {
        return data === null || data === undefined || Object.keys(data).length === 0;
    }

    public static zfill(number: number, width: number) {
        var numberOutput = Math.abs(number); /* Valor absoluto del número */
        var length = number.toString().length; /* Largo del número */
        var zero = "0"; /* String de cero */

        if (width <= length) {
            if (number < 0) {
                return ("-" + numberOutput.toString());
            } else {
                return numberOutput.toString();
            }
        } else {
            if (number < 0) {
                return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
            } else {
                return ((zero.repeat(width - length)) + numberOutput.toString());
            }
        }
    }

    public static mail(mail: string): boolean {
        const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (this.emptyString(mail)) return true;

        if (mail.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    }

    public static listValidation(textoInput: string, validaciones: string[]): boolean {
        for (let validacion of validaciones) {
            // tipos de validaciones se la validacion requiere de un parametro se le asigna ejem: "typovalidacion:parametro"
            let tipoValidacion = validacion.split(":")[0];
            let valor = validacion.split(":").length > 0 ? validacion.split(":")[1] : "";
            switch (tipoValidacion) {
                case "requerido": {
                    if (this.requerido(textoInput))
                        return true;
                    break;
                }
                case "*": {
                    if (this.singo(textoInput))
                        return true;
                    break;
                }
                case "inicia": {
                    if (this.inicia(textoInput))
                        return true;
                    break;
                }
                case "minimo": {
                    if (this.minimo(textoInput, valor))
                        return true;
                    break;
                }
                case "maximo": {
                    if (this.maximo(textoInput, valor))
                        return true;
                    break;
                }
                case "correo": {
                    if (this.correo(textoInput))
                        return true;
                    break;
                }
                case "numerico": {
                    if (this.numerico(textoInput))
                        return true;
                    break;
                }
                case "texto": {
                    if (this.texto(textoInput))
                        return true;

                    break;
                }
                case "decimal": {
                    if (this.decimal(textoInput))
                        return true;

                    break;
                }
                default: {
                    return false;
                }
            }
        }
        return false
    }

    //----- validaciones -------//

    private static requerido(textoInput: string): boolean {
        return this.emptyString(textoInput);
    }

    private static singo(textoInput: string): boolean {
        return this.emptyString(textoInput);
    }

    private static inicia(textoInput: string): boolean {
        return Number(textoInput[0]) != 3;
    }

    private static minimo(textoInput: string, valor: string): boolean {
        return Number(textoInput.length) < Number(valor);
    }

    private static maximo(textoInput: string, valor: string): boolean {
        return Number(textoInput.length) > Number(valor);
    }

    private static correo(textoInput: string,): boolean {
        return !/^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,3})$/.test(textoInput) && textoInput.length > 0;
    }

    private static texto(textoInput: string): boolean {
        return !/^([A-Za-z0-9 ])*$/.test(textoInput) && textoInput.length > 0;

    }

    private static numerico(textoInput: string,): boolean {
        return !/^([0-9])*$/.test(textoInput) && textoInput.length > 0;
    }

    private static decimal(textoInput: string,): boolean {
        return !(/^[0-9]+([,][0-9]+)?$/.test(textoInput) && textoInput.length > 0);
    }

}
